import React, { useState } from 'react';
import './messageBox.css';
import LoadingButton from '../LoadingButton/LoadingButton';

const MessageBox = ({
  message,
  onClose,
  onConfirm,
  onCancel,
  type,
  loading_button = false,
  input = false,
  technicalDetails = null,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = e => {
    setInputValue(e.target.value);
  };

  return (
    <div className="overlay messagebox-overlay">
      <div className="messagebox">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <p className="input" style={{ whiteSpace: 'pre-line' }}>
          {message}
        </p>
        {technicalDetails && (
          <details className="messagebox-technical-details">
            <summary>Détails techniques</summary>
            <pre>{technicalDetails}</pre>
          </details>
        )}
        {input && (
          <div className="messagebox-input-container">
            <input
              className="messagebox-input"
              type="text"
              name="messagebox-input"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        )}
        <div className="messagebox-buttons">
          {type === 'ok' && <button onClick={onConfirm}>OK</button>}
          {type === 'yesno' && (
            <>
              {loading_button ? (
                <LoadingButton onClick={onConfirm}>Oui</LoadingButton>
              ) : (
                <button onClick={onConfirm}>Oui</button>
              )}
              <button onClick={onCancel}>Non</button>
            </>
          )}
          {type === 'input' && (
            <>
              {loading_button ? (
                <LoadingButton onClick={() => onConfirm(inputValue)}>Oui</LoadingButton>
              ) : (
                <button onClick={() => onConfirm(inputValue)}>Valider</button>
              )}
              <button onClick={onCancel}>Annuler</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageBox;
